
const SET_MODE = "UI/SET_MODE";
const SET_RETURN_URL = "UI/SET_RETURN_URL";
const SET_REFERRER = "UI/SET_REFERRER";

const defaultState = {
    mode: null,
    returnUrl: null,
    referrer: ""
};

export function setUIMode(modeType) {
    return {
        type: SET_MODE,
        payload: modeType,
    };
}

export function setReturnURL(path) {
    return {
        type: SET_RETURN_URL,
        payload: path,
    };
}

export function setReferrer(ref) {
    return {
        type: SET_REFERRER,
        payload: ref
    };
}



export function uiReducer(state = defaultState, action) {
    switch (action.type) {
        case SET_MODE:
            return Object.assign({}, state, {
                mode: action.payload
            });
        case SET_RETURN_URL:
            return Object.assign({}, state, {
                returnUrl: action.payload
            });
        case SET_REFERRER:
            return Object.assign({}, state, {
                referrer: action.payload
            });
        default:
            return state;
    }
    return state;
}
